module.exports = __webpack_public_path__ + "static/media/12.081.1865589e.webp";